import React from 'react';
import { usePreview } from '@dashboard/context/PreviewContext';
import useMountEffect from '@dashboard/hooks/useMountEffect';

const ConfirmationPreview = () => {
  const [, previewDispatch] = usePreview();
  useMountEffect(() => {
    previewDispatch({ type: 'set', value: { type: 'confirmationCheckoutMessage' } });
    return () => previewDispatch({ type: 'set', value: { type: 'checkout' } });
  });
  return null;
};

// After booking, attendees are added on the confirmation, so that is where the preview shows them.
export default function GuestsPreview({ page }) {
  const settings = page?.eventDetails?.attendeeDetails;
  const afterBooking = Boolean(settings?.enabled) && settings?.when === 'afterBooking';
  return afterBooking ? <ConfirmationPreview /> : null;
}
